import {
  DbotEvent,
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "../common/commonDomain";
import { ChangeOfAuditor, ChangeOfAuditorForm } from "./auditorDomain";
import { DecisionType } from "../../common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext,
  data?: ChangeOfAuditor,
): ChangeOfAuditorForm {
  return new ChangeOfAuditorForm(dispatch, context, data);
}

export function handleEvent(form: ChangeOfAuditorForm, event: DbotEvent) {
  form.handleEvent(event);
}

export function applyForm(form: ChangeOfAuditorForm): ChangeOfAuditor {
  return {
    type: DecisionType.auditor,
    name: form.selectedAuditor?.name,
    email: form.emailModel.validatedValue,
    organisationNumber: form.selectedAuditor?.organisationNumber,
    businessAddress1: form.selectedAuditor?.businessAddress1,
    businessAddress2: form.selectedAuditor?.businessAddress2,
    businessCity: form.selectedAuditor?.businessCity,
    businessCountry: form.selectedAuditor?.businessCountry,
    businessZip: form.selectedAuditor?.businessZip,
  };
}

export function validate(form: ChangeOfAuditorForm): boolean {
  return form.validate();
}

export function isValid(form: ChangeOfAuditorForm): boolean {
  return form.isValid;
}

export const auditorHandler: DecisionTypeHandler<
  DecisionType.auditor,
  ChangeOfAuditor,
  ChangeOfAuditorForm
> = {
  type: DecisionType.auditor,
  initNewForm,
  handleEvent,
  isValid,
  validate,
  applyForm,
};
